
(function documentContainerDefinition() {
    'use strict';
    angular.module('Entities')
        .service('workspaceService', [
            'restUrlBuilder', '$injector', function workspaceService(restUrlBuilder, $injector) {

                this.getMyWorkspace = function getMyWorkspace(page, itemsPerPage, orderby) {
                    var params = {
                        page: page,
                        itemPerPage: itemsPerPage,
                        orderBy: orderby
                    };

                    return restUrlBuilder.all('Workspace/GetMyWorkspace')
                        .get({ params: params });
                };

            }
        ]);

})();